import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Phone } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Who We Serve', path: '/who-we-serve' },
    { name: 'Careers', path: '/careers' },
    { name: 'Areas We Serve', path: '/areas-we-serve' },
    { name: 'Contact', path: '/contact' },
  ]

  const isActive = (path) => location.pathname === path

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50" data-component-path="client/src/components/Navbar.jsx" data-component-line="1:1" data-component-id="client/src/components/Navbar.jsx:1:1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="2:2" data-component-id="client/src/components/Navbar.jsx:2:2">
        <div className="flex justify-between items-center py-4" data-component-path="client/src/components/Navbar.jsx" data-component-line="3:3" data-component-id="client/src/components/Navbar.jsx:3:3">
          <Link to="/" className="flex items-center gap-3 group mr-12" data-component-path="client/src/components/Navbar.jsx" data-component-line="4:4" data-component-id="client/src/components/Navbar.jsx:4:4">
            <div className="h-24 w-auto rounded-lg flex items-center justify-center flex-shrink-0 transition-opacity duration-200 group-hover:opacity-80" data-component-path="client/src/components/Navbar.jsx" data-component-line="5:5" data-component-id="client/src/components/Navbar.jsx:5:5">
              <img 
                src="https://res.cloudinary.com/dwjmh4kt0/image/upload/v1775042276/vibe/fsrse1/White%20Simple%20Home%20Furnishing%20Logo.png" 
                alt="Refuge Community Outreach Logo" 
                className="h-full w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<svg class="w-12 h-12 text-auburn-700" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"/></svg>';
                }}
                data-component-path="client/src/components/Navbar.jsx" 
                data-component-line="6:6" 
                data-component-id="client/src/components/Navbar.jsx:6:6" 
              />
            </div>
            <div className="flex flex-col justify-center" data-component-path="client/src/components/Navbar.jsx" data-component-line="17:17" data-component-id="client/src/components/Navbar.jsx:17:17">
              <span className="text-xl font-bold text-gray-900 leading-tight whitespace-nowrap" data-component-path="client/src/components/Navbar.jsx" data-component-line="18:18" data-component-id="client/src/components/Navbar.jsx:18:18">Refuge Community</span>
              <span className="text-xl font-bold text-gray-900 leading-tight whitespace-nowrap" data-component-path="client/src/components/Navbar.jsx" data-component-line="19:19" data-component-id="client/src/components/Navbar.jsx:19:19">Outreach</span>
            </div>
          </Link>

          <div className="hidden lg:flex items-center gap-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="24:24" data-component-id="client/src/components/Navbar.jsx:24:24">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-auburn-700'
                    : 'text-gray-700 hover:text-auburn-700'
                }`}
                data-component-path="client/src/components/Navbar.jsx"
                data-component-line="25:25"
                data-component-id="client/src/components/Navbar.jsx:25:25"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:7205380225"
              className="flex items-center justify-center gap-2 h-11 px-6 bg-auburn-700 text-white rounded-lg hover:bg-auburn-800 transition-all duration-200 shadow-md hover:shadow-lg focus:ring-4 focus:ring-auburn-300/50"
              data-component-path="client/src/components/Navbar.jsx"
              data-component-line="40:40"
              data-component-id="client/src/components/Navbar.jsx:40:40"
            >
              <Phone className="w-5 h-5 flex-shrink-0" data-component-path="client/src/components/Navbar.jsx" data-component-line="45:45" data-component-id="client/src/components/Navbar.jsx:45:45" />
              <span data-component-path="client/src/components/Navbar.jsx" data-component-line="46:46" data-component-id="client/src/components/Navbar.jsx:46:46">720.538.0225</span>
            </a>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors duration-200"
            aria-label="Toggle menu"
            data-component-path="client/src/components/Navbar.jsx"
            data-component-line="52:52"
            data-component-id="client/src/components/Navbar.jsx:52:52"
          >
            {isOpen ? <X className="w-6 h-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="58:58" data-component-id="client/src/components/Navbar.jsx:58:58" /> : <Menu className="w-6 h-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="58:58" data-component-id="client/src/components/Navbar.jsx:58:58" />}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200" data-component-path="client/src/components/Navbar.jsx" data-component-line="65:65" data-component-id="client/src/components/Navbar.jsx:65:65">
            <div className="flex flex-col gap-2" data-component-path="client/src/components/Navbar.jsx" data-component-line="66:66" data-component-id="client/src/components/Navbar.jsx:66:66">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive(link.path)
                      ? 'bg-auburn-50 text-auburn-700'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                  data-component-path="client/src/components/Navbar.jsx"
                  data-component-line="67:67"
                  data-component-id="client/src/components/Navbar.jsx:67:67"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:7205380225"
                className="flex items-center justify-center gap-2 h-11 px-6 bg-auburn-700 text-white rounded-lg hover:bg-auburn-800 transition-all duration-200 shadow-md mt-2"
                data-component-path="client/src/components/Navbar.jsx"
                data-component-line="82:82"
                data-component-id="client/src/components/Navbar.jsx:82:82"
              >
                <Phone className="w-5 h-5 flex-shrink-0" data-component-path="client/src/components/Navbar.jsx" data-component-line="86:86" data-component-id="client/src/components/Navbar.jsx:86:86" />
                <span data-component-path="client/src/components/Navbar.jsx" data-component-line="87:87" data-component-id="client/src/components/Navbar.jsx:87:87">720.538.0225</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar